export class VendorListResponseModel {
  count: number;
  next: string;
  previous: string;
  results: VendorListModel[];
}

export class VendorListModel {
  id: number;
  name: string;
  email?: string;
  contact_person?: string;
  phone_number?: string;
  website?: string;
  // Add other fields as needed for dropdown display
}
export class VenueTypeResponseModel {
  count: number;
  next: string;
  previous: string;
  results: VenueTypeModel[];
}

export class VenueTypeModel {
  id: number;
  name: string;
  description?: string;
}
export class VenueResponseModel {
  count: number;
  next: string;
  previous: string;
  results: VenueModel[];
}

export class VenuePocResponseModel {
  count: number;
  next: string;
  previous: string;
  results: any[];
}

export class VenueRoomResponseModel {
  count: number;
  next: string;
  previous: string;
  results: any[];
}

export class VenueInformationResponseModel {
  count: number;
  next: string;
  previous: string;
  results: any[];
}

// export class VenueModel {
//     id: number
//     name: string
//     email: string
//     website: string
//     contact_person: string
//     phone_number: string
//     notes: string
//     categories_serviced: string[]
//     location: string
//     address_1: string
//     address_2: string
//     created_by: number
//     modified_by: number
//     city: number
//     state: number
//     country: number
//     city_details: any[]
//     country_code: number
//     country_code_details: CountryCodeDetails
//     poc_details: PocDetails[]
// }

// const mapVenueResponseToModel = (apiData: any): VenueModel => {
//   const model = new VenueModel();
//   model.id = apiData.id;
//   model.name = apiData.name;
//   model.star_rating = apiData.star_rating;
//   model.address = apiData.address;
//   model.website = apiData.website;
//   model.neighborhood = apiData.neighborhood;
//   model.preference = apiData.preference;
//   model.created_by = apiData.created_by;
//   model.modified_by = apiData.modified_by;
//   model.brand = apiData.brand;
//   model.venue_type = apiData.venue_type;
//   model.city = apiData.city;
//   model.created_by_name = apiData.created_by_name;
//   model.modified_by_name = apiData.modified_by_name;
//   model.vendor_details = apiData.vendor_details;
//   model.venue_type_name = apiData.venue_type_name;
//   model.location_details = apiData.location_details;
//   model.venue_information = apiData.venue_information;
//   model.created_at = apiData.created_at;
//   model.modified_at = apiData.modified_at;
//   // Add any other fields from the response as needed
//   return model;
// };

export class VenueModel {
  id: number;
  name: string;
  star_rating: number;
  address: string;
  website: string;
  neighborhood: string;
  preference: number;
  created_by: number;
  modified_by: number | null;
  brand: number;
  venue_type: number;
  city: number;
  created_by_name: string;
  modified_by_name: string;
  vendor_details: any; // You can create a VendorDetailsModel if you want strict typing
  venue_type_name: string;
  location_details: any; // You can create a LocationDetailsModel if you want strict typing
  venue_information: any;
  created_at: string;
  modified_at: string;

  // Add any other fields from your API response as needed
}

// Mapping function
export const mapVenueResponseToModel = (apiData: any): VenueModel => {
  const model = new VenueModel();
  model.id = apiData.id;
  model.name = apiData.name;
  model.star_rating = apiData.star_rating;
  model.address = apiData.address;
  model.website = apiData.website;
  model.neighborhood = apiData.neighborhood;
  model.preference = apiData.preference;
  model.created_by = apiData.created_by;
  model.modified_by = apiData.modified_by;
  model.brand = apiData.brand;
  model.venue_type = apiData.venue_type;
  model.city = apiData.city;
  model.created_by_name = apiData.created_by_name;
  model.modified_by_name = apiData.modified_by_name;
  model.vendor_details = apiData.vendor_details;
  model.venue_type_name = apiData.venue_type_name;
  model.location_details = apiData.location_details;
  model.venue_information = apiData.venue_information;
  model.created_at = apiData.created_at;
  model.modified_at = apiData.modified_at;
  // Add any other fields from the response as needed
  return model;
};

export class PocDetails {
  contact_person: string;
  country_code: number;
  country_code_details: CountryCodeDetails;
  created_at: string;
  created_by: number;
  created_by_name: number;
  id: number;
  modified_at: string;
  modified_by: number;
  modified_by_name: string;
  phone_number: number;
  venue: number;
}

export class CountryCodeDetails {
  id: number;
  country_name: string;
  code: string;
  country: number;
}

export class OutsourcingRequestVendorResponseModel {
  count: number;
  next: string;
  previous: string;
  results: OutsourcingRequestVendorModel[];
}

export class OutsourcingRequestVendorModel {
  id: number;
  access_token: string;
  vendor_response_status:
    | 'PENDING'
    | 'VIEWED'
    | 'DRAFTING'
    | 'SUBMITTED'
    | 'DECLINED';
  submitted_at: Date;
  is_shortlisted: boolean;
  is_finalized: boolean;
  created_by: number;
  modified_by: number;
  quotation_request: number;
  vendor: number;
  vendor_details?: any;
  quotation_request_details?: any;
  quotation_request_vendor_id: string;
  created_at: Date;
  modified_at: Date;
  created_by_name: string;
}

export class VendorResponseModel {
  count: number;
  next: string;
  previous: string;
  results: VendorModel[];
}

export class VendorModel {
  id: number;
  name: string;
  email: string;
  website: string;
  contact_person: string;
  phone_number: string;
  notes: string;
  categories_serviced: string[];
  location: string;
  address_1: string;
  address_2: string;
  created_by: number;
  modified_by: number;
  city: number;
  state: number;
  country: number;
  city_details: any[];
  country_code: number;
  country_code_details: countryCodeDetails;
  poc_details: PocDetails[];
}

// export class PocDetails{
// contact_person:string
// country_code:number
// country_code_details:countryCodeDetails
// created_at:string
// created_by:number
// created_by_name:number
// id:number
// modified_at:string
// modified_by:number
// modified_by_name:string
// phone_number:number
// vendor:number

// }

export class countryCodeDetails {
  id: number;
  country_name: string;
  code: string;
  country: number;
}

export class City {
  id: number;
  name: string;
  state: number;
}
export class State {
  id: number;
  name: string;
  country: number;
}
export class Country {
  id: number;
  name: string;
  slug: string;
}

export class CountryResponseModel {
  count: number;
  next: string;
  previous: string;
  results: Country[];
  initialValue?: any;
}
export class StateResponseModel {
  count: number;
  next: string;
  previous: string;
  results: State[];
  initialValue?: any;
}
export class CityResponseModel {
  count: number;
  next: string;
  previous: string;
  results: City[];
  initialValue?: any;
}

export class UserDetailModel {
  email: string;
  name: string;
  group_permission: [];
  id: number;
  image: string;
  job_title: string;
  permission: [];
  roles: string;
  type: any;
  is_sales_person: boolean;
  group: number[] = [];
  group_list: { id: number; name: string }[] = [];
  user_group: { id: number; name: string }[] = [];
}

export class UserResponseModel {
  count: number;
  next: string;
  previous: string;
  results: UserDetailModel[];
}

export class VendorSubmissionResponseModel {
  count: number;
  next: string;
  previous: string;
  results: OutsourcingRequestVendorModel[];
}

export class VendorSubmissionModel {
  created_at: string;
  created_by: number;
  created_by_name: string;
  id: number;
  last_saved_at: string;
  modified_at: string;
  modified_by: number;
  modified_by_name: string;
  overall_submission_notes: string;
  quotation_request_vendor: string;
  quotation_request_vendor_details: any;
  submitted_at: string;
  section_details: any;
  amount_before_tax: string;
  currency: number;
  currency_type: string;
  currency_type_details: any;
  exchange_rate: string;
  file: [];
  file_details: any;
  product_details: any[];
  tax: [];
  total_price: string;
  usd_amount: string;
  time_zone: string;
  time_zone_details: any;
}

export class VendorProductModal {
  id: number;
  product: string;
  amount_before_tax: number;
  total_price: number;
  created_by: number;
  modified_by: number;
  submission: number;
  tax: number[];
}

export class VendorSubmissionAnswerReponseModel {
  count: number;
  next: string;
  previous: string;
  results: VendorSubmissionAnswerModel[];
}

export class VendorSubmissionAnswerModel {
  id: number;
  answer_text_short: string;
  answer_text_long: string;
  answer_number: string;
  answer_boolean: boolean;
  answer_date: string;
  answer_selected_choice_ids: string[];
  answer_file_references: string[];
  vendor_comment_on_answer: string;
  submission: number;
  question: number;
  question_details: any;
  submission_details: any;
  created_at: string;
  modified_at: string;
  created_by: number;
  modified_by: number;
}
